module.exports = __webpack_public_path__ + "static/media/GT.388741e5.png";